import React from 'react';
import { useField } from 'formik';

import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';

export const mapping = {
  male: { label: 'Male', value: 'Male' },
  female: { label: 'Female', value: 'Female' },
  other: { label: 'Non-Binary', value: 'Non-Binary' }
};

export default function GenderField({ label, fieldName }) {
  const [field, meta] = useField(fieldName);

  return (
    <div className="form-group form-group-gender">
      <label className="form-label form-label-lg">{label}</label>
      <div className="default-btn-toolbar">
        <ButtonToolbar>
          <ToggleButtonGroup type="radio" {...field}>
            <ToggleButton {...field} value={mapping.male.value}>
              {mapping.male.label}
            </ToggleButton>

            <ToggleButton {...field} value={mapping.female.value}>
              {mapping.female.label}
            </ToggleButton>

            <ToggleButton {...field} value={mapping.other.value}>
              {mapping.other.label}
            </ToggleButton>
          </ToggleButtonGroup>
        </ButtonToolbar>
        {meta.touched && meta.error && (
          <div className="input-feedback">{meta.error}</div>
        )}
      </div>
    </div>
  );
}
